// routes/PermissionRoute.js
//
// Wraps a route element so that, in addition to PrivateRoute's role check,
// direct navigation to the URL is blocked when the signed-in user's
// EFFECTIVE permission (role default + any active user override, per
// usePermissions()/can()) denies the given module/action. This closes the
// gap where PrivateRoute only checks role membership, so a role-permitted
// but user-denied technician could still open the page by typing its URL.
import { Navigate } from "react-router-dom";
import { usePermissions } from "../context/PermissionContext";

export default function PermissionRoute({ children, module, action }) {
  const { can, loading } = usePermissions();

  if (loading) return null;
  if (!can(module, action)) return <Navigate to="/unauthorized" />;

  return children;
}
